import { useState, useCallback, useRef } from "react";
import { GetQuestionnaires } from "../services/fhir/questionnaire/GetQuestionnaires";

interface UseQuestionnairesParams {
    count?: number;
    status?: "active" | "inactive" | "entered-in-error" | "draft";
    title?: string;
    publisher?: string;
    tag?: string;
}

export function useQuestionnaires(initialParams: UseQuestionnairesParams = {}) {
    const [questionnaires, setQuestionnaires] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const loadingRef = useRef(false);
    const stableInitialParamsRef = useRef<UseQuestionnairesParams>(initialParams);

    const fetchQuestionnaires = useCallback(async (params: UseQuestionnairesParams = {}) => {
        // evita chamadas concorrentes
        if (loadingRef.current) return;

        loadingRef.current = true;
        setLoading(true);
        setError(null);

        try {
            const response = await GetQuestionnaires({
                ...stableInitialParamsRef.current,
                ...params,
            });

            const questionnairesList =
                response?.entry?.map((entry: any) => entry.resource) || [];
            setQuestionnaires(questionnairesList);
        } catch (err) {
            setError("Erro ao buscar questionários");
            console.error("useQuestionnaires error:", err);
            setQuestionnaires([]);
        } finally {
            loadingRef.current = false;
            setLoading(false);
        }
    }, []);

    const clearQuestionnaires = useCallback(() => {
        setQuestionnaires([]);
        setError(null);
    }, []);

    return {
        questionnaires,
        loading,
        error,
        fetchQuestionnaires,
        clearQuestionnaires,
    };
}
